import React, {useMemo, useState} from 'react';
import MultiSelectAutocomplete from '../../../../../components/inputs/multi-select-autocomplete';
import {Typography, Stack, IconButton, CircularProgress} from "@mui/material";
import {IconGripVertical, IconX} from "@tabler/icons-react";

export const WatchdogSelection = ({ project, node, setNode, onChangeData, nodes, onUpdate }) => {
  const watchdogs = project?.watchdogs || [];
  const selectedWatchdogs = node?.data?.watchdogs || [];
  const [isLoading, setIsLoading] = useState(false);

  const handleWatchdogChange = async (id) => {
    if (isLoading) return;
    
    setIsLoading(true);
    const ids = selectedWatchdogs ? [...selectedWatchdogs, id] : [id];
    console.log('Selected watchdogs:', ids);
    // onChangeData("watchdogs", ids);
    
    try {
      await onUpdate({...node, data: {...(node?.data || {}), watchdogs: ids}});
    } catch (error) {
      console.error('Error updating node:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveWatchdog = async (watchdogId) => {
    if (isLoading) return;
    
    setIsLoading(true);
    const updatedIds = selectedWatchdogs.filter(id => id !== watchdogId);
    // onChangeData("watchdogs", updatedIds);
    
    try {
      await onUpdate(node);
      await onUpdate({...node, data: {...(node?.data || {}), watchdogs: updatedIds}});
    } catch (error) {
      console.error('Error updating node:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMoveWatchdog = async (fromIndex, toIndex) => {
    if (fromIndex === toIndex || isLoading) return;
    
    setIsLoading(true);
    const updatedIds = [...selectedWatchdogs];
    const [movedItem] = updatedIds.splice(fromIndex, 1);
    updatedIds.splice(toIndex, 0, movedItem);
    
    console.log('Moving from', fromIndex, 'to', toIndex, 'result:', updatedIds);
    // onChangeData("watchdogs", updatedIds);
    
    try {
      await onUpdate({...node, data: {...(node?.data || {}), watchdogs: updatedIds}});
    } catch (error) {
      console.error('Error updating node:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const selectedWatchdogsObjects = useMemo(() => {
    return selectedWatchdogs.map(selectedId => 
      watchdogs.find(watchdog => watchdog.id === selectedId)
    ).filter(Boolean);
  }, [selectedWatchdogs, watchdogs]);

  const filterWatchdogs = useMemo(() => {
    return watchdogs?.filter(watchdog => !selectedWatchdogs.includes(watchdog.id));
  }, [selectedWatchdogs, watchdogs])

  return (
   <>
     <Stack direction="row" alignItems="center" spacing={1}>
       <Typography fontWeight={600} fontSize={".8em"}>Watchdogs</Typography>
       {isLoading && <CircularProgress size={16} />}
     </Stack>
     <MultiSelectAutocomplete
       // label="Watchdogs"
       options={filterWatchdogs || []}
       multiple={false}
       selectedValues={null}
       onChange={handleWatchdogChange}
       getOptionLabel={(option) => option.name}
       getOptionValue={(option) => option.id}
       placeholder="Select watchdogs..."
       size="small"
       blurOnSelect={true}
       disabled={isLoading}
     />
     
     {selectedWatchdogsObjects.length > 0 && (
       <Stack spacing={1} sx={{ mt: 2 }}>
         {selectedWatchdogsObjects.map((watchdog, index) => (
           <Stack
             key={watchdog.id}
             direction="row"
             alignItems="center"
             spacing={1}
             draggable={!isLoading}
             onDragStart={(e) => {
               if (isLoading) {
                 e.preventDefault();
                 return;
               }
               e.dataTransfer.setData('text/plain', index.toString());
               e.dataTransfer.effectAllowed = 'move';
             }}
             onDragOver={(e) => {
               if (isLoading) return;
               e.preventDefault();
               e.dataTransfer.dropEffect = 'move';
             }}
             onDrop={(e) => {
               if (isLoading) return;
               e.preventDefault();
               const fromIndex = parseInt(e.dataTransfer.getData('text/plain'));
               if (fromIndex !== index) {
                 handleMoveWatchdog(fromIndex, index);
               }
             }}
             sx={{
               p: 1,
               border: '1px solid #e0e0e0',
               borderRadius: 1,
               bgcolor: isLoading ? '#f5f5f5' : '#f9f9f9',
               cursor: isLoading ? 'not-allowed' : 'grab',
               '&:active': { cursor: isLoading ? 'not-allowed' : 'grabbing' },
               '&:hover': { bgcolor: isLoading ? '#f5f5f5' : '#f0f0f0' },
               opacity: isLoading ? 0.6 : 1
             }}
           >
             <IconGripVertical size={16} />
             
             <Typography sx={{ flex: 1 }}>
               {watchdog?.name}
             </Typography>
             
             <IconButton
               size="small"
               onClick={(e) => {
                 e.stopPropagation();
                 handleRemoveWatchdog(watchdog.id);
               }}
               color="error"
               onMouseDown={(e) => e.stopPropagation()}
               disabled={isLoading}
             >
               <IconX size={16} />
             </IconButton>
           </Stack>
         ))}
       </Stack>
     )}
   </>
  );
};